<template>
    <div class="drag">
        <div class="drag-box">
            <v-card
                :class="[
          fileName || type === 'form' ? 'inactive' : 'active',
          { 'grey lighten-2': dragover },
        ]"
                flat
            >
                <v-card-text>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div class="d-flex flex-column" align="center" justify="center" v-on="on" v-bind="attrs">
                                <v-icon :class="[]" size="20">
                                    mdi-google-drive
                                </v-icon>
                                <p class="p-info">Desde Google Drive</p>
                                <!--div class="upload-btn-wrapper"-->
                                <!--v-btn
                                  :disabled="fileName != null || type === 'form'"
                                  class="btn"
                                  >Subir archivo</v-btn
                                -->
                                <!--input
                                  :disabled="fileName != null || type === 'form'"
                                  type="file"
                                  id="csv_file"
                                  accept=".csv"
                                  @click="reset($event)"
                                  name="csv_file"
                                  placeholder=""
                                  @change="loadCSV($event)"
                                /-->
                                <!--/div-->
                                <p class="p-max-file-size">&nbsp;</p>
                            </div>
                        </template>
                        <span>Esta opción esta en desarrollo, y por tanto esta dehabilitada</span>
                    </v-tooltip>
                </v-card-text>
            </v-card>
        </div>
        <!--div class="file-container">
          <v-card v-if="fileName">
            <v-row>
              <v-col cols="2" class="text-center">
                <v-icon class="check align-middle">mdi-check</v-icon>
              </v-col>
              <v-col cols="8">
                <v-card-title>
                  {{ fileName }}
                </v-card-title>
                <v-card-subtitle>
                  {{ fileSize }}
                </v-card-subtitle>
              </v-col>
              <v-col cols="2" class="text-center">
                <v-icon @click="clean()" class="trash align-middle"
                  >mdi-delete-outline</v-icon
                >
              </v-col>
            </v-row>
          </v-card>
        </div-->
    </div>
</template>

<script>
//import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "GoogleDriveFilePicker",
    data() {
        return {
            userInserted: null,
            fileName: null,
            dragover: false,
            channel_name: "",
            uploadedFiles: [],
            channel_fields: [],
            channel_entries: [],
            parse_header: [],
            parse_csv: [],
            sortOrders: {},
            files: [],
            fileSize: "",
            sortKey: "",
            multiLine: true,
            snackbar: false,
            required_header: [
                "firstName",
                "secondName",
                "firstLastName",
                "secondLastName",
                "responsibleEmail",
                "domain",
            ],
            text: "Tamaño máximo soportado 5MB.",
            type:null,
        };
    },
    /*computed: {
      ...mapGetters({ type: "getType" }),
    },*/
    filters: {
        capitalize: function (str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
    },
    props: {
        resetData: {
            type: Number,
            default: 0,
        },
    },
    watch: {
        resetData() {
            this.clean();
        },
    },
    destroyed() {
        this.parse_csv = null;
        this.fileName = null;
        /*this.setDataCsv({
          data: this.parse_csv,
          fileName: this.fileName,
          type: null,
        });*/
    },
    methods: {
        /*...mapActions({
          clearData: "clearData",
        }),
        ...mapMutations(["setDataCsv"]),*/
        //TODO: Refactor this method
        reset(e) {
            e.target.value = null;
        },
        onDrop(e) {
            e.preventDefault();
            this.dragover = false;
            // Check if there are already uploaded files
            if (this.uploadedFiles.length > 0) this.uploadedFiles = [];
            if (e.dataTransfer.files.length > 1) {
                this.snackbar = true;
                console.error("Solo puedes ingresar un archivo.");
            } else if (this.fileName) {
                this.snackbar = "true";
                console.error("Primero debes borrar el archivo actual antes de subir otro.");
            } else this.readCSV(e.dataTransfer.files[0]);
        },
        sortBy: function (key) {
            var vm = this;
            vm.sortKey = key;
            vm.sortOrders[key] = vm.sortOrders[key] * -1;
        },
        clean() {
            //this.setDataCsv({ data: [{}], fileName: null, type: null });
            this.channel_name = "";
            this.channel_fields = [];
            this.channel_entries = [];
            this.parse_header = [];
            this.parse_csv = [];
            this.sortOrders = {};
            this.files = [];
            this.fileSize = "";
            this.sortKey = "";
            this.fileName = null;
            this.userInserted = null;
        },
        checkHeaders() {
            this.required_header.forEach((x) => {
                if (!this.parse_header.some((element) => element.includes(x))) {
                    this.snackbar = true;
                    console.error("Las columnas del csv no coinciden con las requeridas, revisa el archivo.");
                    document.getElementById("csv_file").value = "";
                    this.clean();
                }
            });
        },
        csvJSON(csv) {
            let vm = this;
            var lines = csv.split("\n");
            lines.forEach((x, index) => (lines[index] = x.replace(/[\r\n]/g, "")));

            var result = [];
            var headers = lines[0].split(",");
            if (lines[lines.length - 1] === "") {
                lines.pop();
            }

            vm.parse_header = lines[0].split(",");
            //this.checkHeaders();
            if (this.snackbar) return;
            lines[0].split(",").forEach(function (key) {
                vm.sortOrders[key] = 1;
            });

            lines.map(function (line, indexLine) {
                if (indexLine < 1) return; // Jump header line

                var obj = {};
                var currentline = line.split(",");
                headers.map(function (header, indexHeader) {
                    obj[header] = currentline[indexHeader];
                });

                result.push(obj);
            });

            return result; // JavaScript object
        },
        returnFileSize(number) {
            if (number < 1024) {
                return number + "bytes";
            } else if (number >= 1024 && number < 1048576) {
                return (number / 1024).toFixed(1) + "KB";
            } else if (number >= 1048576) {
                if ((number / 1048576).toFixed(1) > 5) {
                    this.snackbar = true;
                    console.error("Tamaño máximo soportado del archivo 5MB.");
                    return null;
                }
                return (number / 1048576).toFixed(1) + "MB";
            }
        },
        readCSV(x) {
            var vm = this;
            this.fileName = x.name;
            var reader = new FileReader();
            reader.readAsText(x);
            this.fileSize = this.returnFileSize(x.size);
            if (!this.fileSize) {
                document.getElementById("csv_file").value = "";
                this.clean();
                return;
            }
            // Handle errors load
            reader.onload = async function (event) {
                var csv = event.target
                    ? event.target.result
                    : event.dataTransfer.result;
                vm.parse_csv = vm.csvJSON(csv);
                /*vm.setDataCsv({
                  data: vm.parse_csv,
                  fileName: vm.fileName,
                  type: "csv",
                });*/
            };
            reader.onerror = function (evt) {
                console.error("ha ocurrido un error al leer el archivo")
                /*const readeable = evt.target
                  ? evt.target.error.name
                  : evt.target.error.name;*/
                if (readeable == "NotReadableError") {
                    alert("Canno't read file !");
                }
            };
        },
        loadCSV(e) {
            if (window.FileReader) {
                this.readCSV(e.target.files[0]);
            } else {
                alert("FileReader are not supported in this browser.");
            }
        },
    },
};
</script>
